// extracted by mini-css-extract-plugin
export default {"btn":"ra","inverse":"sa","small":"ta","tiny":"ua","blinking":"va"};